var map = {
	"./AT.svg": 934,
	"./BP.svg": 935,
	"./BT_BP.svg": 521,
	"./BT_WS.svg": 522,
	"./CO2.svg": 936,
	"./GL.svg": 937,
	"./HR.svg": 938,
	"./PO.svg": 939,
	"./TM.svg": 940,
	"./WS.svg": 941,
	"./ZOE.svg": 942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96;